import { render, staticRenderFns } from "./tuifei.vue?vue&type=template&id=0817b9db&scoped=true"
import script from "./tuifei.vue?vue&type=script&lang=js"
export * from "./tuifei.vue?vue&type=script&lang=js"
import style0 from "./tuifei.vue?vue&type=style&index=0&id=0817b9db&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817b9db",
  null
  
)

export default component.exports